export default "__VITE_PUBLIC_ASSET__61a641b4__"